__turbopack_context__.v({
  "blogsecMonthArrow": "ThingsToDoMonth-module__7nCLuG__blogsecMonthArrow",
  "blogsecMonthCard": "ThingsToDoMonth-module__7nCLuG__blogsecMonthCard",
  "blogsecMonthCardDisabled": "ThingsToDoMonth-module__7nCLuG__blogsecMonthCardDisabled",
  "blogsecMonthGrid": "ThingsToDoMonth-module__7nCLuG__blogsecMonthGrid",
  "blogsecMonthHeader": "ThingsToDoMonth-module__7nCLuG__blogsecMonthHeader",
  "blogsecMonthIconWrap": "ThingsToDoMonth-module__7nCLuG__blogsecMonthIconWrap",
  "blogsecMonthImg": "ThingsToDoMonth-module__7nCLuG__blogsecMonthImg",
  "blogsecMonthLeft": "ThingsToDoMonth-module__7nCLuG__blogsecMonthLeft",
  "blogsecMonthLoading": "ThingsToDoMonth-module__7nCLuG__blogsecMonthLoading",
  "blogsecMonthSection": "ThingsToDoMonth-module__7nCLuG__blogsecMonthSection",
  "blogsecMonthTitle": "ThingsToDoMonth-module__7nCLuG__blogsecMonthTitle",
});
